"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processOrderChangeRequest = void 0;
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const addOrderNote_1 = require("./addOrderNote");
const getOrderById_1 = require("./getOrderById");
const processOrderChangeRequest = async (supabase, order_id, message, to_address) => {
    try {
        // get the order
        const order = await (0, getOrderById_1.getOrderById)(supabase, order_id);
        // create a new order note.
        const note = {
            note: message,
            order_id: order_id,
            pinned: true,
            created_by: order.client?.id,
            type: "CHANGE_REQUEST",
        };
        await (0, addOrderNote_1.addOrderNote)(supabase, note);
        // email support with request details
        const request_support_email = {
            language_code: "en",
            template_id: helpers_1.EMAIL_SUPPORT_ORDER_CHANGE_REQUEST,
            order_id: order.id,
            data: {
                message: message,
            },
        };
        if (to_address) {
            request_support_email.email_address = to_address;
        }
        request_support_email.cc_address = [
            "simon@golfsavers.com",
            "david@golfsavers.com",
        ];
        await (0, sendEmail_1.sendEmail)(request_support_email);
        return true;
    }
    catch (error) {
        throw new Error(error.message);
    }
};
exports.processOrderChangeRequest = processOrderChangeRequest;
